import ILeaseComp from "../interfaces/ILeaseComp";
import useFocusShape from "./useFocusShape";
import useLeaseCompsInsideShape from "./useLeaseCompsInsideShape";

export default function (leaseComps: ILeaseComp[]): ILeaseComp[] {
    return useLeaseCompsInsideShape(leaseComps, useFocusShape());
}